export default __webpack_public_path__ + "static/media/sk.ce1e72ff.png";